import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import i18n from '@/plugins/i18n';
import swal from 'sweetalert2'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    hotels: JSON.parse(sessionStorage.getItem('hotels')) || {},
    rooms: {},
    availableRooms: {},
    unavailableRooms: {},
    // En igangværende booking, mens den bliver lavet og tilrettet
    bookingInProgress: JSON.parse(sessionStorage.getItem('bookingInProgress')) || {'hotel': -1, 'roomtype': '', 'startdate': '0000-00-00', 'enddate': '0000-00-00', 'needs': {'1': 0, '2': 0, 'D': 0, '3': 0, '4': 0, 'P': 0}, 'wants': [], 'ekstras': {}, 'detailedEkstras': {}, 'split': {} },
    // Når en bookingInProgress er færdig til at blive bestilt, bliver den rykket over i toOrder
    toOrder: [],
    ekstras: {},
    customerData: JSON.parse(sessionStorage.getItem('customerData')) || {'name': '', 'address': '' ,'countryCode': '', 'phone': '', 'postnr': '', 'city': '', 'country': '', 'email': '', 'email2': '', 'remarks': '', 'newsletter': false, 'terms': false},
    afterAddonData: JSON.parse(sessionStorage.getItem('afterAddonData')) || {'doorcode': '', 'invoiceno': ''},
    eanData: {'nummer': '', 'myndighed': '', 'reference': ''},
    summaryData: JSON.parse(sessionStorage.getItem('summaryData')) || {},
    loading: false,
    paymentPriceData: {},
    invoice: JSON.parse(sessionStorage.getItem('invoice')) || {},
    addonInvoice: JSON.parse(sessionStorage.getItem('addonInvoice')) || {},
    refNo: {'complete': 0, 'refNo': ''},
    bookingSummary: {},
    addonSummary: {},
    checksum: null,
    qpPayCheck: {},
    back: '',
    discountCode: '0',
    tb_rooms: {},
    restrictions: {},
    rabat: {}
  },
  mutations: {
    hotelData(state, hotels) {
      state.hotels = hotels
      sessionStorage.setItem('hotels', JSON.stringify(state.hotels));
    },
    roomData(state, rooms) {
      state.rooms = rooms
    },
    availableRooms(state, availableRooms) {
      state.availableRooms = availableRooms
    },
    unavailableRooms(state, unavailableRooms) {
      state.unavailableRooms = unavailableRooms
    },
    toOrderData(state, toOrder) {
      state.toOrder = toOrder
      sessionStorage.setItem('toOrder', JSON.stringify(state.toOrder));
    },
    ekstraData(state, ekstras) {
      state.ekstras = ekstras
      sessionStorage.setItem('ekstraData', JSON.stringify(state.ekstras));
    },
    addToCart(state, item) {
      state.bookingInProgress[item.name] = item.value;
      //console.log(JSON.stringify(item));
      sessionStorage.setItem('bookingInProgress', JSON.stringify(state.bookingInProgress));
      //console.log('Ny value for: '+item.name+' : '+state.bookingInProgress[item.name]+' bookingInProgress: '+JSON.stringify(state.bookingInProgress)+' sat i Vuex mutation \'addToCart\'');
    },
    addSplitBookingToCart(state, item) {
      // Nedenstående er droppet da den mister reaktivitet i Vue
      //state.bookingInProgress['split'][item.name] = item.value;

      var oldSplit = { ...state.bookingInProgress['split'] };
      oldSplit[item.name] = item.value;
      state.bookingInProgress = { ...state.bookingInProgress, split: oldSplit };

      //console.log(JSON.stringify(item));
      sessionStorage.setItem('bookingInProgress', JSON.stringify(state.bookingInProgress));
      console.log('Ny value for: '+item.name+' : '+JSON.stringify(item.value)+' bookingInProgress[split]: '+JSON.stringify(state.bookingInProgress['split'])+' sat i Vuex mutation \'addSplitBookingToCart\'');
    },
    addToAfterAddonCart(state, item) {
      state.afterAddonData[item.name] = item.value;
      //console.log(JSON.stringify(item));
      sessionStorage.setItem('afterAddonData', JSON.stringify(state.afterAddonData));
      //console.log('Ny value for: '+item.name+' : '+state.bookingInProgress[item.name]+' bookingInProgress: '+JSON.stringify(state.bookingInProgress));
    },
    customerData(state, customerData) {
      state.customerData = customerData
      sessionStorage.setItem('customerData', JSON.stringify(state.customerData));
    },
    afterAddonData(state, afterAddonData) {
      state.afterAddonData = afterAddonData
      sessionStorage.setItem('afterAddonData', JSON.stringify(state.afterAddonData));
    },
    eanData(state, eanData) {
      state.eanData = eanData
    },
    summaryData(state, summaryData) {
      state.summaryData = summaryData
      sessionStorage.setItem('summaryData', JSON.stringify(state.summaryData));
    },
    loadingData(state, loading) {
      state.loading = loading
    },
    paymentPriceData(state, paymentPriceData) {
      state.paymentPriceData = paymentPriceData
    },
    refNo(state, refNo) {
      state.refNo.refNo = refNo;
      state.refNo.complete = 1; // Indikerer at API load er complete
      //sessionStorage.setItem('refNo', JSON.stringify(state.refNo));
    },
    invoice(state, invoiceData) {
      state.invoice = invoiceData;
      sessionStorage.setItem('invoice', JSON.stringify(state.invoice));
    },
    addonInvoice(state, invoiceData) {
      state.addonInvoice = invoiceData;
      sessionStorage.setItem('addonInvoice', JSON.stringify(state.addonInvoice));
    },
    bookingSummary(state, bookingSummary) {
      state.bookingSummary = bookingSummary;
    },
    addonSummary(state, addonSummary) {
      state.addonSummary = addonSummary;
    },
    rabat(state, rabat) {
      state.rabat = rabat;
    },
    checksum(state, checksum) {
      state.checksum = checksum;
    },
    qpPayCheck(state, qpPayCheck) {
      state.qpPayCheck = qpPayCheck;
    },
    backData(state, back) {
      state.back = back;
    },
    discountCode(state, discountCode) {
      state.discountCode = discountCode;
    },
    tb_rooms(state, tb_rooms) {
      state.tb_rooms = tb_rooms;
    },
    restrictions(state, restrictions) {
      state.restrictions = restrictions;
    }
  },
  actions: {
    async getHotelData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ url: '/hotels/'+payload.koncern, errorHandle: true})
          .then(resp => {
            const hotels = resp.data
            commit('hotelData', hotels)
            resolve(resp)
          })
          .catch(err => {
            swal.fire({
              icon: 'error',
              title: i18n.t('fejl'),
              text: i18n.t('errorGetHotelData'),
              showCloseButton: true,
              showConfirmButton: false,
            })
       
            //console.log('Fejl i at hente API data');
            reject(err)
          })
      })
    },
    async getRoomData({ commit }, payload) {
      // Hvis der ikke er angivet en occupancy, så undlad at sende parametren med
      if(!payload.occupancy) {
        payload.occupancy = '';
      } else {
        payload.occupancy = '/'+payload.occupancy;
      }
      return new Promise((resolve, reject) => {
        axios({ url: '/hotelAvailability/roomType/'+payload.roomType+'/koncern/'+payload.koncern+'/hotel/'+payload.hotel+'/start/'+payload.start+'/end/'+payload.end+''+payload.occupancy})
          .then(resp => {
            const rooms = resp.data
            commit('roomData', rooms)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getAvailableRooms({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ url: '/availableRooms/koncern/'+payload.koncern+'/hotel/'+payload.hotel+'?start='+payload.start+'&end='+payload.end+'&rooms='+payload.rooms})
          .then(resp => {
            const rooms = resp.data
            commit('availableRooms', rooms)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getUnAvailableRooms({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ url: '/unavailableRooms/hotel/'+payload.hotel+'?start='+payload.start+'&end='+payload.end+'&rooms='+payload.rooms})
          .then(resp => {
            const rooms = resp.data
            commit('unavailableRooms', rooms)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getEkstras({ commit }, payload) {
      console.log('getEkstras kaldt - roomtype: '+payload.type);
      return new Promise((resolve, reject) => {
        axios({ url: '/extras/koncern/'+payload.koncern+'/hotel/'+payload.hotel+'/la/'+payload.la+'/type/'+payload.type})
          .then(resp => {
            const ekstras = resp.data
            commit('ekstraData', ekstras)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getSummaryData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: '/koncern/'+payload.koncern+'/summary', data: payload})
          .then(resp => {
            const summaryData = resp.data
            commit('summaryData', summaryData)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    async getPaymentPriceData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: '/paymentPrices/koncern/'+payload.koncern+'/postnr/'+payload.hotel})
          .then(resp => {
            const paymentPriceData = resp.data
            commit('paymentPriceData', paymentPriceData)
            resolve(resp)
          })
          .catch(err => {
            //console.log(err);
            reject(err)
          })
      })
    },

    async getRefNo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: '/koncern/'+payload.koncern+'/createRefNo', data: payload})
          .then(resp => {
            const refNo = resp.data
            commit('refNo', refNo)
            resolve(resp)
          })
          .catch(err => {
            //console.log(err);
            reject(err)
          })
      })
    },

    async getAddonRefNo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: '/koncern/'+payload.koncern+'/createAddonRefNo', data: payload})
          .then(resp => {
            const refNo = resp.data
            commit('refNo', refNo)
            resolve(resp)
          })
          .catch(err => {
            //console.log(err);
            reject(err)
          })
      })
    },


    async getInvoice({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: '/koncern/'+payload.koncern+'/booking', data: payload, errorHandle: true})
          .then(resp => {
            const invoice = resp.data
            commit('invoice', invoice)
            resolve(resp)
          })
          .catch(err => {
            swal.fire({
              icon: 'error',
              title: i18n.t('fejl'),
              text: i18n.t('errorBooking'),
              showCloseButton: true,
              showConfirmButton: false,
            })

            //console.log(err);
            reject(err)
          })
      })
    },

    async getBookingSummary({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: '/koncern/'+payload.koncern+'/booking/' + payload.refNo, errorHandle: true})
          .then(resp => {
            const bookingSummary = resp.data
            commit('bookingSummary', bookingSummary)
            commit('loadingData', true)
            resolve(resp)
          })
          .catch(err => {
            swal.fire({
              icon: 'error',
              title: 'Fejl',
              text: 'Bookingen findes ikke',
              showCloseButton: true,
              showConfirmButton: false,
            })

            //console.log(err);
            reject(err)
          })
      })
    },

    async getAddonInvoice({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: '/koncern/'+payload.koncern+'/bookingAddon', data: payload, errorHandle: true})
          .then(resp => {
            const addonInvoice = resp.data
            commit('addonInvoice', addonInvoice)
            resolve(resp)
          })
          .catch(err => {
            swal.fire({
              icon: 'error',
              title: i18n.t('fejl'),
              text: i18n.t('errorBooking'),
              showCloseButton: true,
              showConfirmButton: false,
            })

            //console.log(err);
            reject(err)
          })
      })
    },
    
    async getAddonSummary({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: '/koncern/'+payload.koncern+'/booking/' + payload.refNo, errorHandle: true})
          .then(resp => {
            const addonSummary = resp.data
            commit('addonSummary', addonSummary)
            commit('loadingData', true)
            resolve(resp)
          })
          .catch(err => {
            swal.fire({
              icon: 'error',
              title: 'Fejl',
              text: 'Bookingen findes ikke',
              showCloseButton: true,
              showConfirmButton: false,
            })

            //console.log(err);
            reject(err)
          })
      })
    },

    addToCart({commit}, item) {
      //console.log('Tilføjer '+JSON.stringify(item)+' til cart');
      commit('addToCart', item)
    },
    addSplitBookingToCart({commit}, item) {
      //console.log('Tilføjer '+JSON.stringify(item)+' til cart');
      commit('addSplitBookingToCart', item)
    },
    addToAfterAddonCart({commit}, item) {
      //console.log('Tilføjer '+JSON.stringify(item)+' til cart');
      commit('addToAfterAddonCart', item)
    },
    addOrder({commit}, order) {
      //console.log('Tilføjer '+JSON.stringify(item)+' til cart');
      commit('toOrderData', order)
    },
    addCustomerData({commit}, item) {
      commit('customerData', item)
    },

    // Bruges af login til efter-tilkøb - henter bookinginfo ved valid invoide/doorcode
    async addAfterAddonData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: 'koncern/'+ payload.koncern +'/getRefNo', data:payload, errorHandle: true})
          .then(refNoResponse => {
            axios({ method: 'get', url: 'koncern/'+ payload.koncern +'/booking/'+ refNoResponse.data, data:payload, errorHandle: true })
            .then(bookingInfoResponse => {
              const refNo = refNoResponse.data
              const bookingInfo = bookingInfoResponse.data
              if(refNoResponse.status !== 200) {
                reject('bad credentials: '+refNo)
              }
              commit('loadingData', false)
              commit('afterAddonData', bookingInfo)
              resolve(refNoResponse)
            })
          })
          .catch(err => {
            swal.fire({
              icon: 'error',
              title: i18n.t('fejl'),
              text: i18n.t('errorAddonLogin'),
              //text: 'Custom fejl ved login...',
              showCloseButton: true,
              showConfirmButton: false,
            })
            reject(err)
          })
      })
    },

    // Henter info om rabatkode
    async getDiscountCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: 'rabat/' + payload.email2 +'/' + payload.koncern+ '/' +payload.hotel + '/' + payload.start + '/' + payload.end})
          .then(resp => {
            const rabat = resp.data
            commit('rabat', rabat)
            commit('loadingData', true)
            resolve(resp)
          })
          .catch(err => {
            reject(err)
          })
      })
    },    

    addEanData({commit}, item) {
      commit('eanData', item)
    },
    toggleLoading({commit}, value) {
      commit('loadingData', value)
    },
    async getChecksum({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: 'koncern/'+ payload.koncern +'/payment/checksum'+payload.adminOrder, data: payload})
          .then(resp => {
            const checksum = resp.data
            commit('checksum', checksum)
            commit('loadingData', true)
            resolve(resp)
          })
          .catch(err => {
            //console.log(err);
            reject(err)
          })
      })
    },
    async qpPayCheck({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: '/payment/check/'+ payload.koncern + '/' + payload.postnr + '/' + payload.refNo})
        .then(resp => {
          const qpPayCheck = resp.data
          commit('qpPayCheck', qpPayCheck)
          commit('loadingData', true)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    back({commit}, value) {
      commit('backData', value)
    },
    async checkDiscountCode({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: '/rabatcheck/' + payload.id + '/' + payload.koncern + '/' + payload.hotel + '/' + payload.start + '/' + payload.end})
        .then(resp => {
          const discountCode = resp.data
          commit('discountCode', discountCode)
          commit('loadingData', false)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    async saveVenteliste({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'post', url: '/venteliste', data: payload})
        .then(resp => {
          commit('loadingData', false)
          swal.fire({
            icon: 'success',
            title: i18n.t('ventelisteGemt'),
            text: i18n.t('ventelisteGemtText'),
            showCloseButton: false,
            showConfirmButton: true,
          })
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
      })
    },
    async getTb_rooms({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: '/rooms/koncern/'+payload.koncern+'/'+payload.postnr})
          .then(resp => {
            const roomData = resp.data
            commit('tb_rooms', roomData)
            resolve(resp)
            commit('loadingData', false)
          })
          .catch(err => {
            console.log(err);
            reject(err)
          })
      })
    },    
    async getRestrictions({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios({ method: 'get', url: payload.koncern+'/'+payload.postnr+'/restrictions/'+payload.start+'/'+payload.end})
          .then(resp => {
            const restrictions = resp.data
            commit('restrictions', restrictions)
            resolve(resp)
            commit('loadingData', false)
          })
          .catch(err => {
            console.log(err);
            reject(err)
          })
      })
    },
  },
  getters: {
    hotels: state => state.hotels,
    rooms:  state => state.rooms,
    bookingInProgress: state => state.bookingInProgress,
    toOrder: state => state.toOrder,
    availableRooms: state => state.availableRooms,
    unavailableRooms: state => state.unavailableRooms,
    ekstras: state => state.ekstras,
    customerData: state => state.customerData,
    afterAddonData: state => state.afterAddonData,
    eanData: state => state.eanData,
    summaryData: state => state.summaryData,
    loading: state => state.loading,
    paymentPriceData: state => state.paymentPriceData,
    refNo: state => state.refNo,
    invoice: state => state.invoice,
    bookingSummary: state => state.bookingSummary,
    checksum: state => state.checksum,
    qpPayCheck: state => state.qpPayCheck,
    back: state => state.back,
    discountCode: state => state.discountCode,
    tb_rooms: state => state.tb_rooms,
    restrictions: state => state.restrictions,
    rabat: state => state.rabat
  }
})
